// src/redux/appointmentSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Swal from 'sweetalert2';

// Async thunk
export const acceptAppointment = createAsyncThunk(
  'appointment/accept',
  async (id, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    if (role !== 'superadmin') {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'Only Superadmin can accept appointments',
      });
      return rejectWithValue('Unauthorized');
    }

    try {
      const response = await fetch(`https://api.thevisaman.in/api/appointments/accept/${id}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Something went wrong');
      }

      Swal.fire({
        icon: 'success',
        title: 'Appointment Accepted',
        text: data.message,
      });

      return data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed',
        text: error.message,
      });
      return rejectWithValue(error.message);
    }
  }
);

const acceptAppointmentSlice = createSlice({
  name: 'appointment',
  initialState: {
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(acceptAppointment.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(acceptAppointment.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(acceptAppointment.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default acceptAppointmentSlice.reducer;
